<template>
  <div  id="app">
    <!-- <div  class="wrapApp">
      <router-view/>
    </div> -->
    <div  class="wrapApp" v-cloak>
      <RightNav ></RightNav>
      <NavHeader class="center"></NavHeader>
      <router-view/>
      <Footer></Footer>
    </div>
    
  </div>
</template>

<script>
import NavHeader from '@/components/header'
import Footer from '@/components/footer'
import RightNav from '@/components/RightNav'
export default {
  components: {
    NavHeader, Footer, RightNav
  },
  name: 'App',
  // mounted () {
  //   const script = document.createElement('script')
  //   script.src = 'https://v1.cnzz.com/z_stat.php?id=1279820165&web_id=1279820165'
  //   script.language = 'JavaScript'
  //   document.body.appendChild(script)
  // },
  watch: {
    '$route' () {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  }
}
</script>
<style>
    .wrapApp{
      font-family: "Open Sans","PingFang SC","Microsoft YaHei","Helvetica Neue","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;

      min-width: 1240px;
    }

    [v-cloak] {
      display: none;
    }
  .center{
    width: 1240px;
    margin: 0 auto;
    height: auto;
    background: #ffffff;

    padding: 0px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue